module.exports = __webpack_public_path__ + "fonts/Roboto-Black.2b8d6922.woff2";